import React, { useState } from "react";
import { styled } from "@mui/system";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import SearchIcon from "@mui/icons-material/Search";
import colors from "assets/theme-dark/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

interface SearchDatasetCardsProps {
  onSearch: (query: string) => void;
}

const StyledSearchContainer = styled(MDBox)`
  display: flex;
  align-items: center;
  width: ${pxToRem(200)};
  margin-bottom: ${pxToRem(16)};
`;

const SearchDatasetCards: React.FC<SearchDatasetCardsProps> = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchQuery(query);
    onSearch(query);
  };

  return (
    <StyledSearchContainer>
      <MDInput
        fullWidth
        placeholder="Search datasets..."
        value={searchQuery}
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: <SearchIcon sx={{ color: colors.text.secondary }} />,
        }}
        sx={{
          "& .MuiInputBase-root": {
            "& fieldset": { borderWidth: "0.5px", borderColor: colors.text.main },
            "&:hover fieldset": { borderColor: colors.primary.main },
            "&.Mui-focused fieldset": { borderColor: colors.primary.main },
            color: colors.text.main,
          },
          "& .MuiInputBase-input": {
            color: "#1A1A1A",
            height: pxToRem(23),
            py: pxToRem(8.5),
          },
          "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder": {
            color: "#1A1A1A",
          },
        }}
      />
    </StyledSearchContainer>
  );
};

export default SearchDatasetCards;
